var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-wait',{attrs:{"for":"fetch_secret_questions"}},[_c('template',{slot:"waiting"},[_c('LoaderComponent')],1),_c('v-container',[(this.whichRealm)?_c('Header'):_vm._e(),_c('router-view')],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }